<!--
 * @Author: xuxiaofei
 * @Date: 2022-11-02 14:52:31
 * @LastEditTime: 2022-11-02 17:00:15
 * @LastEditors: 许晓飞 xuxiaofei.xxffe@sunyur.com
 * @Description: 需求提报详情页
 -->
<template>
  <div class="demand-submission-dialog">
    <Buttons v-if="demandId || demandId === 0" type="link" @click.stop="dialogVisible = true">{{triggerButtonTitle}}</Buttons>
    <sy-popup
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :before-close="handleClose">
      <detaile-page
        v-bind="$attrs"
        :demandId="dialogVisible ? demandId : null"
        :showDataTip="true"
        pageType="popup"
      />
      <span slot="footer" class="dialog-footer">
        <Buttons type="primary" @click="dialogVisible = false">{{closeButtonTitle}}</Buttons>
      </span>
    </sy-popup>
  </div>
</template>

<script>
import DetailePage from './page.vue'
import { SyPopup, Buttons } from './../../../../index.js'
import i18n from './i18n.js'
import { componentMessage } from './../../utils'
const pageText = window.fe.getPageText(i18n)
export default {
  name: 'DemandSubmission',
  components: {
   DetailePage,
   SyPopup,
   Buttons
  },
  props: {
    // 需求提报的id
    demandId: {
      type: [Number, String],
      required: true
    },
		// 弹窗标题
		dialogTitle: {
			type: String,
			default: pageText.purchaseDesc
		},
    // 弹窗触发按钮文案
    triggerButtonTitle: {
      type: String,
      default: pageText.viewMore
    },
    // 关闭按钮文案
    closeButtonTitle: {
      type: String,
      default: pageText.close
    }
	},
  data () {
    return {
      // 弹窗是否显示
      dialogVisible: false,
      pageText
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  async created () {
    let verifyResult = componentMessage(['purchaser', 'supplier', 'mall'], '需求提报详情组件')
		if (verifyResult) return
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.demand-submission-dialog {
  display: inline-block;
}
</style>
